import {
  ContainerMFE,
  useGetFeatureFlags,
  FeatureFlagKeyValues,
  BackgroundProcess
} from '@uma/react-commons/dist/index';
import React, { useMemo } from 'react';
import {
  DependencyManagerProvider,
  useDependencyManagerContext
} from 'src/contexts/dependencyManager';
import Router from 'src/router';
import '../styles/globals.scss';
import * as T from './types';

export interface FeatureFlagProps {
  isLoading: boolean;
  originalFeedbackExperience: boolean;
  findMoreOfYourPlansOnlyForUs: boolean;
}

const AppComponent: React.FC<T.AppPropsType> = () => {
  const { northboundAPIs } = useDependencyManagerContext();

  const client = useMemo(
    () => northboundAPIs.v1.graphql.getClient(),
    [northboundAPIs.v1.graphql]
  );

  const GraphQLProvider = useMemo(
    () => northboundAPIs.v1.graphql.reactTools.createGraphQLProvider(React),
    [northboundAPIs.v1.graphql.reactTools]
  );

  const featureFlagClient = useMemo(
    () => northboundAPIs?.v1?.featureFlags?.getClient,
    [northboundAPIs?.v1?.featureFlags?.getClient]
  );

  const featureFlagProps = useGetFeatureFlags({
    getClient: featureFlagClient,
    keys: [
      FeatureFlagKeyValues.originalFeedbackExperience,
      FeatureFlagKeyValues.findMoreOfYourPlansOnlyForUs
    ]
  });

  return (
    <GraphQLProvider client={client}>
      <ContainerMFE data-testid="subscriptions-page">
        <Router {...featureFlagProps} />
      </ContainerMFE>
    </GraphQLProvider>
  );
};

const MemoizedAppComponent = React.memo(AppComponent);

const App: React.FC<T.AppPropsType> = () => {
  return (
    <>
      <BackgroundProcess />
      <DependencyManagerProvider>
        <MemoizedAppComponent />
      </DependencyManagerProvider>
    </>
  );
};

export default App;
